import { Box } from '@mui/material';
import { Role } from 'API';
import React, { useContext } from 'react';
import { MH_ROLES } from 'services/auth';
import UserContext from 'shared/contexts/UserContext';

interface FieldRoleLinesProps {
  roles: Role[]
}

const FieldRoleVisibility: React.FC<FieldRoleLinesProps> = ({
  roles,
}) => {
  const [userState] = useContext(UserContext);
  const { role, isUserVisibilityToggleOn } = userState;
  const isMH = MH_ROLES.includes(role);
  const showFNLine = roles.includes(Role.FOREIGNNATIONAL);
  const showEMLine = roles.includes(Role.EMPLOYER);
  if (!(isMH && isUserVisibilityToggleOn) || !roles.length) return null;

  const lineBaseSx = {
    position: 'absolute',
    bottom: 0,
    height: '3px',
    width: '30px',
  };

  return (
    <>
      {showFNLine && (
        <Box
          sx={{
            ...lineBaseSx,
            backgroundColor: '#DA7941',
            ...(showEMLine && { left: 0 }),
          }}
        />
      )}
      {showEMLine && (
        <Box
          sx={{
            ...lineBaseSx,
            backgroundColor: '#546587',
            ...(showFNLine && { left: '35px' }),
          }}
        />
      )}
    </>
  );
};

export default FieldRoleVisibility;
